import {inject, Injectable} from '@angular/core';
import {BaseService} from './base.service'
import {catchError, map, shareReplay, take} from 'rxjs/operators'
import {Permission, PERMISSION_ADMINISTRATE, PERMISSION_CREATE, PERMISSION_DELETE, PERMISSION_WRITE} from '../interfaces/Permission'
import {CompoApiService} from './compo-api.service'
import {EMPTY, of} from 'rxjs'
import {Environment} from '../interfaces/Environment'
// Relative import вместо barrel 'compob2b-auth' разрывает circular dep:
// auth.service → libs barrel → permissions.service → auth barrel → auth.module
// (top-level JwtModule.forRoot({tokenGetter: AuthService.tokenGetter}) крашится
// потому что AuthService ещё в середине evaluation). На runtime результат тот же.
import {AuthService} from '../../../../compob2b-auth/src/lib/services/auth.service'
import {StoreService} from './store.service'

@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BaseService {
  compoApiService = inject(CompoApiService);
  environment = inject(Environment);
  authService = inject(AuthService);
  storeService = inject(StoreService);

  loadDamCatalogPermissions(catalogId: number) {
    if (!this.environment.damNewPermissions) {
      const permissions = new Permission();
      if (this.authService.isAdmin()) {
        permissions.myPermissions = [PERMISSION_WRITE, PERMISSION_CREATE, PERMISSION_DELETE, PERMISSION_ADMINISTRATE];
      }

      return of(permissions);
    }

    if (catalogId == 0) {
      catalogId = 1;
    }

    return this.loadDamItemPermissions(catalogId, '/DamCatalog');
  }

  loadDamItemPermissions(id: number, type: string = '') {
    return this.compoApiService
      .get<Permission>('/dam/permissions/' + id + type)
      .pipe(
        catchError(err => this.handleError(err)),
        take(1),
        shareReplay(1),
        map(response => new Permission(response.data))
      );
  }

  canEditPermissionsForItem(permissions: Permission): boolean {
    return !this.storeService.forbiddenError() && permissions?.write;
  }

  canEditPermissionsForCatalog(permissions: Permission): boolean {
    return !this.storeService.forbiddenError() && permissions?.administration;
  }

  handleError(err) {
    if (err?.status === 403) {
      this.storeService.forbiddenError.set(true);
      return EMPTY;
    } else {
      return super.handleError(err);
    }
  }

}


